<template>
  <a-form-item label="批次" name='batch_sn'>
    <a-select :style="{width:type!=='select'?'180px':'100%'}" @change="change" show-search v-model:value="batchSn" :mode="mode">
      <a-select-option value="" v-if="type!=='select'">全部</a-select-option>
      <a-select-option :key='item.batch_sn' :value="item.batch_sn" v-show="item.usable_num >0" v-for='item in list'>
        {{item.batch_sn}}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script>
  import { codeBatchsOptions,codeBatchsSceneOptions } from "@/api/qrcode";
  import { onMounted, ref, watch } from "vue";
  import { iscode } from "@/utils/app";
  export default {
    props: {
      batch_sn: {
        type: String || Array,
        default(){
          return null
        }
      },
      mode: {
        type: String,
        default(){
            return null
        }
      },
      application:{
        type: String,
        default(){
            return null
        }
      },
      type: {
        type: String,
          default(){
          return ''
        }
      }
    },
    name: "codeBatchs",
    setup(props, { emit }) {
      const list = ref([]);
      const batchSn = ref();
      const getCodeBatchsOptions = async () => {
        var res;
        if(props.application){
          res = await codeBatchsOptions().then((res) => res.data);
        }else{
          res = await codeBatchsSceneOptions().then((res) => res.data);
        }
        if (iscode(res)) {
          list.value = res.data;
        }
      };
      let watcher = watch(props, () => {
        if (props.batch_sn) {
          if (!watcher) return;
          batchSn.value = props.batch_sn;
          watcher = null;
        }
      });
      const change = (e) => {
        if (e instanceof Array) {
          var batchs = []
          list.value.forEach(element => {
            e.forEach(v => {
              if (v == element.batch_sn) {
                batchs.push(element)
              }
            })
          });
          emit("change", batchs);
        } else {
          list.value.forEach(element => {
            if (element.batch_sn == e) {
              emit("change", element);
            }
          });
        }
        emit("update:value", e);

      };
      onMounted(() => {
        getCodeBatchsOptions();
      });
      return {
        list,
        change,
        batchSn,
      };
    },
  };
</script>